import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

import type { User } from 'views/App/Portal/LexID/Users/_types/user';

export default function useManageOrganizationUser() {
  const create = async (
    organizationId: string,
    data: User,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/admin-user/v1/organizations/${organizationId}/users`;
    await fetcher({
      method: 'post',
      url,
      body: data,
    })
      .then((data) => {
        if (callback) callback(data.id);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const update = async (
    organizationId: string,
    id: string,
    data: User,
    callback?: (data: User) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/admin-user/v1/organizations/${organizationId}/users/${id}`;
    await fetcher({
      method: 'put',
      url,
      body: data,
    })
      .then((data) => {
        if (callback) callback(data);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    create,
    update,
  };
}
